import { render, staticRenderFns } from "./CallInfoCard.vue?vue&type=template&id=6627ce58&scoped=true"
import script from "./CallInfoCard.vue?vue&type=script&lang=js"
export * from "./CallInfoCard.vue?vue&type=script&lang=js"
import style0 from "./CallInfoCard.vue?vue&type=style&index=0&id=6627ce58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6627ce58",
  null
  
)

export default component.exports